import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const About = lazy(() => import('../pages/about/page'));
const Banking = lazy(() => import('../pages/banking/page'));
const Technology = lazy(() => import('../pages/technology/page'));
const Security = lazy(() => import('../pages/security/page'));
const Pricing = lazy(() => import('../pages/pricing/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const FAQ = lazy(() => import('../pages/faq/page'));
const AccountOpening = lazy(() => import('../pages/account-opening/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/banking',
    element: <Banking />,
  },
  {
    path: '/technology',
    element: <Technology />,
  },
  {
    path: '/security',
    element: <Security />,
  },
  {
    path: '/pricing',
    element: <Pricing />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/faq',
    element: <FAQ />,
  },
  {
    path: '/account-opening',
    element: <AccountOpening />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
